import { createFileRoute } from "@tanstack/react-router"
import { AdminAuditLogList } from "~/components/Admin/AdminAuditLogList"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

import type { ReactElement } from "react"

function AdminAuditLogListPage() {
  return (
    <>
      <CustomHead />
      <div>
        <AdminAuditLogList />
      </div>
    </>
  )
}

function AdminAuditLogListPageWrapper() {
  return (
    <SuperAdminLayout>
      <AdminAuditLogListPage />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/audit")({
  component: AdminAuditLogListPageWrapper,
})
